// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-column-clustered';

export const Component = () => (
  <path d='M1 0v21h21v1H0V0h1Zm8 5v14H6.5V5H9Zm10-3v17h-2.5V2H19ZM5.5 12v7H3v-7h2.5Zm10 1v6H13v-6h2.5Z' />
);

export const viewBox = '0 0 22 22';
